import React from "react";
import { Link } from "react-router-dom";
import logoMark from "../../Asset/ZT-Sidebar-logo.svg";

/*
  Figma card: 403 × 459, 20px radius, #F6F6F6 surface.
    221px  gradient media panel (127.73px mark centred in it)
     21px  gap
     58px  title      - Jakarta 600 / 24 / 29 / -1px, 2 lines
      9px  gap
     87px  excerpt    - Inter 400 / 16 / 28.88, 3 lines
     20px  gap
     23px  "Read Article"
     20px  bottom padding
  The two clamps hold the title and excerpt to their designed line counts, so
  the card lands on 459px without a hard height that would clip longer copy on
  narrow screens.
*/
const MEDIA_GRADIENT = "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)";

const BlogCard = ({ post }) => {
  const { title, excerpt, path, cover } = post;

  return (
    <Link
      to={path}
      aria-label={`Read article: ${title}`}
      className="group flex w-full flex-col overflow-hidden rounded-[20px] bg-[#F6F6F6] transition-shadow duration-300 hover:shadow-[0_10.73px_32.19px_-12.88px_#173A8C24] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#3AB1F6]"
    >
      {/* Media panel */}
      <div
        className="relative h-[221px] w-full shrink-0 overflow-hidden"
        style={{ background: MEDIA_GRADIENT }}
      >
        {cover ? (
          /*
            Covers are product screenshots with their own aspect ratio, so they
            are contained rather than cropped - the gradient shows through
            around them instead of the artwork being cut off.
          */
          <img
            src={cover}
            alt=""
            className="h-full w-full object-contain p-[10px]"
            loading="lazy"
          />
        ) : (
          <img
            src={logoMark}
            alt=""
            aria-hidden="true"
            className="absolute left-1/2 top-1/2 h-[127.73px] w-[127.73px] -translate-x-1/2 -translate-y-1/2"
            loading="lazy"
          />
        )}
      </div>

      <div className="flex flex-1 flex-col px-[20px] pb-[20px] pt-[21px]">
        <h3 className="line-clamp-2 font-jakarta text-[24px] font-semibold capitalize leading-[29px] tracking-[-1px] text-[#141A2E]">
          {title}
        </h3>

        <p className="mt-[9px] line-clamp-3 font-inter text-[16px] font-normal leading-[28.88px] tracking-[0px] text-[#4C5670]">
          {excerpt}
        </p>

        <span className="mt-auto pt-[20px] font-inter text-[15px] font-semibold leading-[1.5] tracking-[0px] text-[#3AB1F6] group-hover:underline">
          Read Article
        </span>
      </div>
    </Link>
  );
};

export default BlogCard;
